import { all, put, select, spawn, takeEvery } from "redux-saga/effects";
import { ApplicationState } from "..";
import { getAll } from "../../repo/logo";
import { fetchAllLogosSuccess } from "./actions";
import { LogoActions, Logo } from "./types";

export const existingLogoState = (state: ApplicationState) =>
  state.terminalLogos.data;

function* handleFetchAll() {
  let logos: Logo[] | undefined = yield select(existingLogoState);

  if (logos && logos.length > 0) {
    yield put(fetchAllLogosSuccess(logos));
  } else {
    logos = yield getAll();

    if (logos && logos.length > 0) {
      yield put(fetchAllLogosSuccess(logos));
    }
  }
}

function* watchhandleFetchAll() {
  yield takeEvery(LogoActions.FETCH_ALL, handleFetchAll);
}

export default function* terminalLogoSaga() {
  yield all([spawn(watchhandleFetchAll)]);
}
